import React, { useReducer } from 'react';


const reducer = (navigation, action) => {

	switch(action.type){

		case "GOTO_STEP":
			let newStep;
			if (action.step == 'accommodation') {
				newStep = navigation.hasHotels ? 'accommodation' : 'accommodationTypes';
			} else {
				newStep = action.step;
			}

			let progressStep = 2;
			switch( newStep ) {
				case 'itinerary':
					progressStep = 2;
					break;
				case 'submit':
					progressStep = 3;
					break;
			}
			return {...navigation, step: { path: newStep, params: action.params }, progress: progressStep, modal: closeModal(), error: resetErrors() };

		case "SET_PROGRESS":
			return {...navigation, progress: action.progress };

		case "RAISE_ERROR":
			return {...navigation, error: setError( action.message, action.code, action.object, action.context )};

		case "RAISE_FIELD_ERRORS":
			return {...navigation, error: setFieldErrors( action.errors )};
		
		case "RESET_ERRORS":
			return {...navigation, error: resetErrors()};

		case "START_PROCESSING":
			return {...navigation, processing: true};

		case "STOP_PROCESSING":
			return {...navigation, processing: false};

		case "OPEN_MODAL":
			return {...navigation, modal: openModal( action.modal, action.title, action.payload )};
		
		case "CLOSE_MODAL":
			return {...navigation, modal: closeModal()};

		case "TRACK_EVENT":
			//track( action, navigation.loggedIn );
			return navigation;
		
		default:
			throw new Error('Where will this go?');

	}

}

const openModal = ( type, title, payload ) => {
	return {
		open: true, 
		type: type,
		title: title,
		payload: payload
	}
}

const closeModal = ( action ) => {
	return {
		open: false, 
		type: null,
		title: null,
		payload: null
	}
}

const setError = ( error, code, object, context ) => {
	
	
	if( object != undefined && object != null ) {
		error = (object.response != undefined && object.response.data.message != undefined ) ? object.response.data.message : object.message;
	}
	
	return { 
		message: error,
		fields: [],
		code: code != undefined ? code : null,
		context: context != undefined && context != null ? context : 'global'
	}
		
}

const setFieldErrors = ( errors ) => {
	const keys = errors.map( err => err.key )
	return { 
		message: errors[0].msg,
		fields: keys,
		code: null
	}
		
}

const resetErrors = () => {
	return { 
		message: false,
		fields: [],
		code: null,
		context: 'global'
	}	
}

let timeout;
const track = ( action, loggedIn ) => {
	clearTimeout(timeout);
	
	if( !loggedIn ) {
		if( typeof UXTracker != 'undefined' ) {
			UXTracker.push({
				type: action.action,
				category: action.category,
				name: action.name,
				trigger: action.trigger,
				data: action.data
			});
		} else {
			timeout = setTimeout(() => {
				track( action, loggedIn );
			}, 0)
		}
	}

}

export default function NavigationReducer( siteId, destinationId, destinationSlug, destinationName, forceHotel, hasPackages, hasSuperPackages, loggedIn ) {
    const initialState = {
		siteId: siteId,
		tag: siteId == 17 ? 'Hen' : 'Stag',
		destination: {
			id: destinationId,
			slug: destinationSlug,
			name: destinationName,
			forceHotel: forceHotel,
			hasSuperPackages: hasSuperPackages
		},
		loggedIn: loggedIn,
		hasHotels: false,
		hasPackages: hasPackages,
		step: {
			path: 'itinerary',
			params: null
		},
		progress: 1,
		error: {
			message: false,
			fields: [],
			code: null,
			context: 'global'
		},
		modal: { 
			open: false, 
			type: null,
			title: null,
			payload: null
		},
		processing: false
    }
    return useReducer(reducer, initialState);
}
